module.exports = __webpack_public_path__ + "static/2CategoryIcons-dea37c053bb26a8654f04894ebb496e0.svg";